import Reflux from 'reflux';

const IndexerOverviewActions = Reflux.createActions({
  list: { asyncResult: true },
});

export default IndexerOverviewActions;



// WEBPACK FOOTER //
// ./src/actions/indexers/IndexerOverviewActions.jsx